/* RESON V2 - tier-selector.js
   Bundle-style PDP quantity tiers with per-unit colour pickers. Each tier's
   price = sum of its selected variants' live prices x tier %, so the number
   shown always matches the % automatic discount. On gift tiers the real case +
   keychain are added (zeroed by the Buy X Get Y automatic discount at checkout). */
(function () {
  function init(root) {
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-tier-config]').textContent) || {}; } catch (e) {}
    var currency = cfg.currency || '$';
    var sym = currency.indexOf('$') >= 0 ? currency : currency + '$';
    function money(cents) { return sym + (Math.round(cents) / 100).toFixed(2); }

    var addBtn = root.querySelector('[data-tier-add]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-tier-input]'));
    if (!addBtn || !inputs.length) return;

    function tierOf(inp) { return inp.closest('.tsel__tier'); }
    function selectorsIn(tier) { return Array.prototype.slice.call(tier.querySelectorAll('[data-tier-variant]')); }
    function priceOf(el) {
      if (el.tagName === 'SELECT') {
        var o = el.options[el.selectedIndex];
        return (o && parseInt(o.getAttribute('data-price'), 10)) || 0;
      }
      return parseInt(el.getAttribute('data-price'), 10) || 0;
    }
    function fullPrice(tier, pairs) {
      var els = selectorsIn(tier);
      if (!els.length) return 0;
      if (els.length === pairs) {
        return els.reduce(function (a, el) { return a + priceOf(el); }, 0);
      }
      return priceOf(els[0]) * pairs; /* single hidden variant (no colour options) */
    }
    function selected() {
      for (var i = 0; i < inputs.length; i++) { if (inputs[i].checked) return inputs[i]; }
      return inputs[0];
    }

    function recompute() {
      inputs.forEach(function (inp) {
        var tier = tierOf(inp);
        var pairs = parseInt(inp.getAttribute('data-pairs'), 10) || 1;
        var pct = parseFloat(inp.getAttribute('data-pct')) || 0;
        var full = fullPrice(tier, pairs);
        var disc = Math.round(full * (100 - pct) / 100);
        var totalEl = tier.querySelector('[data-tier-total]');
        var compareEl = tier.querySelector('[data-tier-compare]');
        if (totalEl) totalEl.textContent = money(disc);
        if (compareEl) {
          if (pct > 0) { compareEl.textContent = money(full); compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        tier.classList.toggle('is-selected', inp.checked);
      });
      var sel = selected();
      var tier = tierOf(sel);
      var pairs = parseInt(sel.getAttribute('data-pairs'), 10) || 1;
      var pct = parseFloat(sel.getAttribute('data-pct')) || 0;
      var disc = Math.round(fullPrice(tier, pairs) * (100 - pct) / 100);
      addBtn.textContent = (pairs > 1 ? 'Add ' + pairs + ' pairs - ' : 'Add to bag - ') + money(disc);
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-tier-input]')) { recompute(); return; }
      if (e.target.matches('[data-tier-variant]')) {
        var row = e.target.closest('.tsel__vrow');
        var img = row && row.querySelector('[data-vthumb]');
        var opt = e.target.options && e.target.options[e.target.selectedIndex];
        if (img && opt && opt.getAttribute('data-image')) img.src = opt.getAttribute('data-image');
        recompute();
      }
    });

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var sel = selected();
      var tier = tierOf(sel);
      var pairs = parseInt(sel.getAttribute('data-pairs'), 10) || 1;
      var els = selectorsIn(tier);
      var counts = {};
      if (els.length === pairs) {
        els.forEach(function (el) { var id = parseInt(el.value, 10); if (id) counts[id] = (counts[id] || 0) + 1; });
      } else if (els.length) {
        var id = parseInt(els[0].value, 10); if (id) counts[id] = pairs;
      }
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      if (!items.length) return;
      if (sel.getAttribute('data-gifts-free') === '1') {
        (root.getAttribute('data-gift-ids') || '').split(',').filter(Boolean).forEach(function (gid) {
          items.push({ id: parseInt(gid, 10), quantity: 1, properties: { _gift: 'Free gift' } });
        });
      }
      if (window.RESONCart) window.RESONCart.add(items);
    });

    recompute();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tier-selector]').forEach(init);
  });
})();
